import React, { useEffect } from "react";

import { Route, Routes, useLocation, useParams } from "react-router-dom";
import {
    PreparationSectionType,
    routeBatchPreparation,
    routeBulkParcelUpload,
    routeConsultShippedParcel,
    routeDeliveryOrderCanceled,
    routeImportData,
    routeExportOperationProducts,
    routeParcelManagement,
    routePickAndPack,
    routePrepareParcelShipping,
    routeReporting,
    routeShipParcel,
    routeCanceledParcel,
    routeStockouts,
    routeReviewReadyToShip,
} from "../../navigation/preparation-route-props";
import { BatchPreparation } from "./batch-preparation/batch-preparation";
import { DeliveryOrderCancelled } from "./delivery-order-canceled/delivery-order-cancelled";
import { OperationBatchSelector } from "./operation-batch-selector/operation-batch-selector";
import { ParcelManagement } from "./parcel-management/parcel-management";
import { ParcelPrepareShipping } from "./parcel-prepare-shipping/parcel-prepare-shipping";
import { ParcelCanceled } from "./parcel-canceled/parcel-canceled";
import { ParcelShipment } from "./parcel-shipment/parcel-shipment";
import { ParcelShipped } from "./parcel-shipped/parcel-shipped";
import { Parcelling } from "./parcelling/parcelling";
import { PickAndPackComponent } from "./pick-and-pack/pick-and-pack";
import { PrinterProgressDrawer } from "./printer/printer-progress-drawer";
import { ReportingPage } from "./reporting/reporting";
import { ImportModule } from "./import-data/import-module";
import { Stockouts } from "./stockouts/stockouts";
import { BulkParcelUpload } from "./bulk-parcel-upload/bulk-parcel-upload";
import { CustomDocumentPrinter } from "./printer/custom-document-printer";
import { ExportOperationProducts } from "./export-operation-products/export-operation-products";
import { ReviewReadyToShip } from "./review-ready-to-ship/review-ready-to-ship";

export interface IOperationRouterProps {
    setRouteExpanded: (route: PreparationSectionType) => void;
}

export const OperationRouter = (props: IOperationRouterProps) => {
    useEffect(() => {
        props.setRouteExpanded("operations");
    }, []);

    const params = useParams();
    const { pathname } = useLocation();

    const renderNotSelectedBatchContent = () => {
        if (!params.batchId) {
            return <div data-testid="batch-not-selected" />;
        }
        return undefined;
    };

    const routesWithoutBatchSelector = [routeImportData, routeExportOperationProducts];

    return <>
        <OperationBatchSelector notDisplayBatchSelector={routesWithoutBatchSelector.some(route => pathname.includes(route))}/>
        <Routes>
            <Route path={`${routeBatchPreparation}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<BatchPreparation />} />
            <Route path={`${routeParcelManagement}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<ParcelManagement />} />
            <Route path={`${routePrepareParcelShipping}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<ParcelPrepareShipping />} />
            <Route path={`${routeShipParcel}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<ParcelShipment />} />
            <Route path={`${routeReviewReadyToShip}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<ReviewReadyToShip  />} />
            <Route path={`${routeConsultShippedParcel}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<ParcelShipped />} />
            <Route path={`${routeCanceledParcel}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<ParcelCanceled />} />
            <Route path={`${routeDeliveryOrderCanceled}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<DeliveryOrderCancelled />} />
            <Route path={`${routeStockouts}/:operationCode/:batchId/:deliveryOrderId?`}
                   element={<Stockouts />} />
            <Route path={`${routeReporting}/:operationCode/validate`} element={<ReportingPage withOperationDataValidationPopup/>} />
            <Route path={`${routeReporting}/:operationCode/report-issue`} element={<ReportingPage withOperationDataReportPopup/>} />
            <Route path={`${routeReporting}/:operationCode?/:batchId?`} element={<ReportingPage/>} />
            <Route path={`${routePickAndPack}/:operationCode?/:batchId?`} element={<PickAndPackComponent />} />
            <Route path={`${routeBulkParcelUpload}/:operationCode?/:batchId?`} element={<BulkParcelUpload />} />
            <Route path={`${routeImportData}/:operationCode/*`} element={<ImportModule />} />
            <Route path={`${routeExportOperationProducts}/:operationCode/*`} element={<ExportOperationProducts/>} />
        </Routes>
            {renderNotSelectedBatchContent()}
             <PrinterProgressDrawer />
             <CustomDocumentPrinter />
             <Parcelling />
         </>;
};
